<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs sem-calls">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap custom-primary"
		>
			<div class="o-stack__cell">
				<h5 class="calls-title">
					{{ sectiontitle }}
					<span *ngIf="hasData">
						<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank">
							<img class="download-icon-svg" src="{{ downloadIcon }}" />
						</a>
					</span>
				</h5>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div *ngIf="!hasData" class="no-data-min-ht">
				<div>No Data Found</div>
			</div>
			<div *ngIf="hasData">
				<div class="graph-filter">
					<div class="filterLabel" [ngClass]="{ 'answered-inactive': graphFilterDisabled }">
						<span>Filter Answered Calls:</span>
					</div>
					<div [ngClass]="{ 'graph-filter-option': true, 'answered-inactive': graphFilterDisabled }">
						<div
							*ngFor="let graphFilterOption of graphFilterOptions"
							class=""
							[ngClass]="{ 'tertiary-color-bg': true, 'active-item': selectedValue == graphFilterOption.id }"
							(click)="filterChange(graphFilterOption.id)"
						>
							{{ graphFilterOption.name }}
						</div>
					</div>
				</div>
				<div class="calls-data">
					<div class="call-metrics">
						<div class="item">
							<div class="data primary-color">{{ metricsData.answeredCalls | number }}</div>
							<div class="table-text"><span>Total Answered Calls</span></div>
						</div>
						<div class="item">
							<div class="data primary-color">{{ metricsData.avgDuration}}</div>
							<div class="table-text"><span>Avg. Duration (HH:MM:SS)</span></div>
						</div>
						<div class="item">
							<div class="data primary-color">{{ metricsData.missedCalls | number }}</div>
							<div class="table-text"><span>Total Missed Calls</span></div>
						</div>
					</div>
				</div>
				<div class="calls-graph-area">
					<div id="chart" #graphArea></div>
				</div>
			</div>
		</div>
	</div>
</div>
